var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticStyle:{"font-size":"24px","line-height":"28px","font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.brand)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","line-height":"1.2"},domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }